import { DevelopmentType, KnowingType, Questions } from "./wizard.types";

export const processAction = (
  value: any,
  currentStep: keyof Questions,
  setCurrentStep: (step: keyof Questions) => void,
  setData: (data: any) => void,
  finalize: () => void
) => {
  setData((prev: any) => ({ ...prev, [currentStep]: value }));
  switch (currentStep) {
    case "2":
      setCurrentStep(value == KnowingType.Know ? "3.1.1" : "3.2.1");
      break;
    case "3.1.1":
      setCurrentStep("3.1.2");
      break;
    case "3.1.2":
      setCurrentStep(value == DevelopmentType.Switcher ? "3.1.3.1" : "3.1.3.2");
      break;

    case "3.1.3.1":
      setCurrentStep("4.1");
      break;

    case "3.1.3.2":
      setCurrentStep("4.1");
      break;

    case "4.1":
      setCurrentStep("4.2");
      break;

    case "4.2":
      setCurrentStep("4.3");
      break;

    case "4.3":
      setCurrentStep("4.4");
      break;

    case "4.4":
      setCurrentStep("5");
      finalize();
      break;

    case "3.2.1":
      setCurrentStep("ict1");
      break;

    case "ict1":
      setCurrentStep("ict2");
      break;
    case "ict2":
      setCurrentStep("ict3");
      break;
    case "ict3":
      setCurrentStep("zorg1");
      break;
    case "zorg1":
      setCurrentStep("zorg2");
      break;
    case "zorg2":
      setCurrentStep("zorg3");
      break;
    case "zorg3":
      setCurrentStep("creatief1");
      break;
    case "creatief1":
      setCurrentStep("creatief2");
      break;
    case "creatief2":
      setCurrentStep("creatief3");
      break;
    case "creatief3":
      setCurrentStep("techniek1");
      break;
    case "techniek1":
      setCurrentStep("techniek2");
      break;
    case "techniek2":
      setCurrentStep("techniek3");
      break;
    case "techniek3":
      setCurrentStep("onderwijs1");
      break;
    case "onderwijs1":
      setCurrentStep("onderwijs2");
      break;
    case "onderwijs2":
      setCurrentStep("onderwijs3");
      break;
    case "onderwijs3":
      setCurrentStep("4.1");
      break;

    default:
      setCurrentStep("2");
      break;
  }
};
